/**
 * @Description: axios二次封装
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-11-17 15:53:23
 */

/**
 * 接收响应数据有两种方式
 * 1.使用链式操作来接收.then(res=>{}).catch(err=>{})
 * 2.使用async await来接收建议外层搭配上try catch
 */

import axios from "axios";
import qs from "qs";
import Vue from "vue"; //vue配合elementUI消息提示组件使用
import { toCode } from "../utils/encryption";
// 请求超时[config]:showTimeout    1.[true]:提示超时弹出框
// 请求超时[config]:reconnect      [true]:自动重连三次
axios.defaults.timeout = 600000; //设置超时时间
axios.defaults.withCredentials = true; //允许跨域携带凭证
axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Access-Control-Allow-Methods"] =
  "GET, POST, PATCH, PUT, DELETE, OPTIONS";
axios.defaults.headers["Access-Control-Allow-Headers"] =
  "Origin, Content-Type, X-Auth-Token";
axios.defaults.headers.get["X-Requested-With"] = "XMLHttpRequest"; //Ajax get请求标识
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest"; //Ajax post请求标识
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=utf-8"; //POST请求参数获取不到的问题
axios.defaults.headers.post["Accept"] = "application/json"; //POST请求参数获取不到的问题
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest"; //Ajax put请求标识
axios.defaults.headers.delete["X-Requested-With"] = "XMLHttpRequest"; //Ajax delete请求标识
axios.defaults.headers["platform"] = "kimshift"; //平台标识

/* axios请求拦截器 */
axios.interceptors.request.use((config) => {
  let user = window.sessionStorage.getItem("userInfo"); //TODO:根据自己项目需求修改
  const token = window.sessionStorage.getItem("token"); //TODO:根据自己项目需求修改
  /* 利用缓存的登录信息设置请求头 */
  try {
    if (user) {
      user = JSON.parse(user); //将JSON字符串转JSON对象
      config.headers["userId"] = user.username;
    }
    /* 携带token值 */
    if (token) {
      config.headers.Authorization = token;
      let appToken = { time: Date.now(), host: window.location.host };
      config.headers.AppToken = toCode(JSON.stringify(appToken));
    }
    //get请求添加附带时间戳参数
    if (config.method == "get") {
      config.params = {
        ...config.params,
        _t: Date.now(),
      };
    }
  } catch (error) {
    console.log("请求异常:", error);
  } finally {
    /*  */
    /**
     * showTimeout优先级比reconnect高
     * showTimeout:请求超时，显示提示
     * reconnect:请求超时，自动重连3次
     */
    config.showTimeout = true; //超时提示
    // config.reconnect = true //超时自动重连默认开启
    return config;
  }
});
/* axios响应拦截器 */
axios.interceptors.response.use(
  (res) => res,
  (error) => {
    const { response, code, config } = error;
    const responseData = {
      code: 500,
      data: null,
      message: "系统繁忙,请联系管理员！",
    };
    if (response) {
      switch (response.status) {
        case 401: //=>权限问题
          responseData.message = "权限异常：401";
          break;
        case 403: //服务器拒绝执行（token过期了）
          responseData.message = "服务器拒绝执行/token过期了：403";
          break;
        case 404: //请求失败，未找到
          responseData.message = "请求失败：404";
          break;
        case 500: //服务器的程序码出错时
          responseData.message = "Internal Server Error";
        case 502: //代理服务器无响应
          responseData.message = "代理服务器无响应";
          break;
        default:
          responseData.message = "系统繁忙,请联系管理员！";
          console.log("服务器异常响应:", response);
      }
      if (!(response.status === 500 && config.responseType === "blob")) {
        // 状态码500且是接收文件流的话额外进行处理
        response.data = responseData;
      }
    } else if (code === "ECONNABORTED") {
      responseData.message = "请求超时!";
      if (config.showTimeout) {
        return new Promise((resolve) => {
          Vue.prototype
            .$confirm("网络请求超时是否重试？", "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "error",
            })
            .then(() => {
              resolve(axios.request({ ...config }));
            });
          // const timeoutModal = confirm({
          //   title: '提示',
          //   content: '请求超时是否重试？',
          //   onOk: () => {
          //     timeoutModal.destroy()
          //     resolve(axios.request({ ...config }))
          //   },
          //   onCancel: () => {
          //     timeoutModal.destroy()
          //   },
          // })
        });
      } else if (config.reconnect) {
        //请求超时，自动重新连接
        if (config.reconnectCount === 4) {
          return {
            status: 500,
            data: responseData,
            config: { responseType: "" },
          };
        } else {
          const count = config.reconnectCount || 1;
          console.log(`重连第${count}次:${config.url}`);
          return new Promise((resolve) => {
            resolve(
              axios.request({
                ...config,
                reconnectCount: count + 1,
              })
            );
          });
        }
      }
    } else {
      if (!window.navigator.onLine) {
        /* 自定义断网处理 */
        responseData.message = "请连接网络服务!";
        return {
          status: 500,
          data: responseData,
          config: { responseType: "" },
        };
      }
    }
    return response;
  }
);
export default axios; //默认导出原对象

/*******
 * @description: 对 (get post put delete) 方法进行二次封装
 * @author: 琴时
 * @param {url}      请求路径
 * @param {formData} 请求负载/body参数
 * @param {params}   请求字符串参数/query参数
 * @param {config}   请求头参数
 * @return {Promise} 服务器响应后再二次处理好的Promise对象
 */

/* 增 */
/**
 * 默认'Content-Type': 'application/json'，可在头部参数config中，修改Content-Type
 */
export const post = (url, formData, params, config = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, formData, { params: params, ...config })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/* 删 */
export const remove = (url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, { params: params, ...config })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/* 改 */
export const update = (url, formData, params, config = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, formData, { params: params, ...config })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/* 查 */
export const query = (url, params, config = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: params, ...config })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/* 表单形式提交:请求头config 上面已设置Content-Type默认application/x-www-form-urlencoded;charset=UTF-8 */
export const postForm = (url, formData, params, config = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(formData), { params: params, ...config })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/* FormData数据流 */
export const postFormData = (url, formData, params, config = {}) => {
  const form = new FormData();
  for (const key in formData) {
    if (Object.hasOwnProperty.call(formData, key)) {
      const element = formData[key];
      const type = element?.constructor;
      if ([Array, Object].includes(type)) {
        form.append(key, JSON.stringify(element));
      } else if (type !== undefined) {
        form.append(key, element);
      }
    }
  }
  return new Promise((resolve, reject) => {
    axios
      .post(url, form, { params: params, ...config })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/* 接收文件流 */
export const acceptFile = (url, formData, params, config = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, formData, { params: params, responseType: "blob", ...config })
      .then((res) => {
        if (res.data?.type === "application/json") {
          // 没有返回正常的流
          const reader = new FileReader();
          reader.readAsText(res.data, "utf-8");
          reader.onload = () => {
            const result = JSON.parse(reader.result);
            resolve(result);
          };
        } else if (res.status !== 200) {
          // 响应异常
          resolve(res.data);
        } else {
          // 正常响应
          const responseData = {
            code: 200,
            data: res.data,
            message: "success",
          };
          resolve(responseData);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
